import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import NavbarMob from "./NavbarMob";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Navbar2 from "./Navbar2";
import Navbar2Mob from "./Navbar2Mob";

function CanApplied() {
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const employeeId = sessionStorage.getItem("employeeId");
    const customerName = sessionStorage.getItem("customerName");
    // console.log(customerName);

    const [packageSelections, setPackageSelections] = useState([]);
    const [jobDetails, setJobDetails] = useState([]);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    // Fetch package selections from API
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getPackageSelectionsByCustomerName/${customerName}`);
                const result = await response.json();

                if (result.message === "Data retrieved successfully") {
                    setPackageSelections(result.data);
                    // console.log(result);
                } else {
                    console.error("Error: ", result.message);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        if (customerName) {
            fetchData();
        }
    }, [customerName, apiBaseUrl]);

    // Fetch job details for each jobId and display under its respective jobId
    useEffect(() => {
        const fetchJobDetails = async (jobId) => {
            try {
                const response = await fetch(`${apiBaseUrl}/getjobposts/${jobId}`);
                const result = await response.json();

                if (result) {
                    setJobDetails((prevState) => {
                        // Only add job details if it's not already in the state
                        if (!prevState.some((job) => job.job_id === result.job_id)) {
                            return [...prevState, result];
                        }
                        // console.log(result);
                        return prevState;
                    });
                } else {
                    console.error("Error fetching job details.");
                }
            } catch (error) {
                console.error("Error fetching job details:", error);
            }
        };

        // Fetch job details for each job in packageSelections
        packageSelections.forEach((item) => {
            if (item.jobId) {
                fetchJobDetails(item.jobId);
            }
        });
    }, [packageSelections]);

    const formatDate = (isoString) => {
        if (!isoString || isoString === "0") return "N/A"; // fallback if no date

        const date = new Date(isoString);

        // Option 1: January 29, 2025
        return date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });

        // Option 2: 29 January 2025
        // return date.toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' });

        // Option 3: 29/01/2025
        // return date.toLocaleDateString('en-GB', { year: 'numeric', month: 'numeric', day: 'numeric' });
    };

    // Create a set of jobIds with valid details from the second API
    const validJobIds = new Set(jobDetails.map((job) => job.job_id));

    const sortedApplications = packageSelections
        .filter((item) => validJobIds.has(item.jobId)) // Only show if job details exist
        .map((item) => {
            const job = jobDetails.find((j) => j.job_id === item.jobId);

            // Use the timestamp from package selection as the application date
            const appliedDate =
                item.created_at && item.created_at !== "0" && item.created_at !== null
                    ? new Date(item.created_at)
                    : new Date(0); // fallback old date

            return {
                ...item,
                jobDetails: job,
                appliedDate, // This is now the correct application date
            };
        })
        .sort((a, b) => b.appliedDate - a.appliedDate); // Newest applications first// Descending: newest first

    return (
        <div className="flex flex-col min-h-screen">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="md:flex hidden">
                <Navbar2 />
            </div>
            <div className="md:hidden flex flex-col">
                <Navbar2Mob />
            </div>
            <div className="flex lg:px-12 px-3 py-12 flex-col min-h-screen bg-[#eeebeb]">
                <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-6">
                    {sortedApplications.map((application) => {
                        const job = application.jobDetails;

                        return (
                            <div key={application.id} className="bg-white rounded-lg shadow-lg p-6">
                                <div className="mt-4">
                                    <h3 className="font-[700] font-display">
                                        <strong>Job ID:</strong>
                                        {job.manualJobID && job.manualJobID !== "0" ? job.manualJobID : job.job_id}{" "}
                                    </h3>
                                    {/* <p>
                                        <strong>Job:</strong> {job.job || "N/A"}
                                    </p>
                                    <p>
                                        <strong>At:</strong> {job.shopName || "N/A"}
                                    </p>
                                    <p>
                                        <strong>Location:</strong> {job.location || "N/A"}
                                    </p>
                                    <p>
                                        <strong>Whatsapp:</strong> {job.whatsapp_number || "N/A"}
                                    </p> */}
                                    <p className="font-[200] font-display text-gray-600">
                                        {application.created_at &&
                                        application.created_at !== "0" &&
                                        application.created_at !== null
                                            ? formatDate(application.created_at)
                                            : "Date not available"}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default CanApplied;
